import axios from 'axios'
import service from '@/utils/request.js'

function getNowFormatDate() {
  var date = new Date();
  var seperator1 = "/";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}
function upLoadOssAliYunUrl(option) {
  var fileName = option.file.name
  var fileBinary = option.file
  var ossDir = `honda_pc/${getNowFormatDate()}/${fileName}`
  return new Promise(function(resolve, reject) {
    service.getRequest('/common/oss/getSignUrl', {
      "ossDir": ossDir
    }).then(res => {
      let url = res;
      axios({
        url: url,
        method: "PUT",
        data: fileBinary,
        headers: {
          'Content-Type': 'application/octet-stream'
        }
      }).then((response) => {
        resolve(ossDir)
      }).catch((error) => {
        console.error('上传失败:', error)
        reject(error)
      })
    }).catch((error) => {
      console.error('获取签名URL失败:', error)
      reject(error)
    })
  });
}


function getImageUrl(_filename) {
	return new Promise((resolve, reject) => {
		service.getRequestJson(`/common/oss/tempUrl`, { ossDir: _filename }).then(res => {
			resolve(res)
		})
	})
}

export default {
  upLoadOssAliYunUrl,
  getImageUrl
}